import { Map, fromJS } from 'immutable';

import AuthService from './AuthService.js';
import {
  CHANGE_USERINFO_SUCCESS,
  LOAD_USER_INFO_ERROR,
  LOAD_USER_INFO_START,
  LOAD_USER_INFO_SUCCESS,
  LOAD_USUARIO_LOGADO_ERROR,
  LOAD_USUARIO_LOGADO_START,
  LOAD_USUARIO_LOGADO_SUCCESS,
  LOGIN_ERROR,
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS
} from './Types.js';

const initialState = Map({
  isLoading: false,
  logged: false,
  userInfo: undefined
});

export default function auth(state = initialState, action) {
  if (state === initialState) {
    const token = AuthService.getAuthorizationToken();
    const userInfo = fromJS(AuthService.getUserInfo());

    state = state.set('preLogged', !!token);

    if (userInfo) {
      state = state.set('userInfo', userInfo);
    }
  }

  switch (action.type) {
    case LOGIN_START:
    case LOAD_USER_INFO_START:
    case LOAD_USUARIO_LOGADO_START:
      return state.set('isLoading', true);

    case LOGIN_ERROR:
    case LOAD_USER_INFO_ERROR:
    case LOAD_USUARIO_LOGADO_ERROR:
      return state.set('isLoading', false);

    case LOGOUT_SUCCESS:
      return state
        .set('userInfo', undefined)
        .set('logged', false)
        .set('preLogged', false);

    case CHANGE_USERINFO_SUCCESS: {
      const { entidade, exercicio } = action.payload;

      return state
        .setIn(['userInfo', 'entidade'], fromJS(entidade))
        .setIn(['userInfo', 'exercicio'], fromJS(exercicio));
    }

    case LOGIN_SUCCESS:
      return state.set('isLoading', false).set('logged', true);

    case LOAD_USUARIO_LOGADO_SUCCESS: {
      const reduceFavoritos = (map, favorito) => {
        map[favorito.seletor.seletor] = favorito;
        return map;
      };
      const accessFavoritos = action.payload.favoritos.reduce(
        reduceFavoritos,
        {}
      );

      return state
        .setIn(['userAccess', 'favoritos'], fromJS(accessFavoritos))
        .setIn(['userAccess', 'modulos'], fromJS(action.payload.modulos))
        .set('isLoading', false);
    }

    case LOAD_USER_INFO_SUCCESS: {
      const reduceAccess = (map, tela) => {
        map[tela.seletor.id] = tela;
        return map;
      };
      const access = action.payload.telas.reduce(reduceAccess, {});

      const userInfo = {
        ...action.payload,
        entidade: action.payload.entidade || action.payload.entidadePadrao,
        exercicio: action.payload.exercicio || action.payload.exercicioPadrao
      };

      delete userInfo.telas;

      return state
        .set('userInfo', fromJS(userInfo))
        .setIn(['userAccess', 'telas'], fromJS(access))
        .set('isLoading', false)
        .set('logged', true);
    }

    default:
      return state;
  }
}
